import type { RouteRecordRaw } from 'vue-router'

import { organizationDetailLayoutMeta } from './shared'

const routeSupplierDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/relations/OrganizationDetailView.vue')
  },
  name: 'supplier-detail',
  path: '',
}

const routeSupplierFileOverview: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/file/SubmenuFiles.vue')
  },
  name: 'supplier-file-overview',
  path: 'file-overview',
}

const routeSupplierAccounting: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/supplier/SubmenuAccounting.vue')
  },
  name: 'supplier-accounting',
  path: 'supplier-accounting',
}

const routeSupplierBuying: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/viewsExternal/submenus/supplier/SubmenuBuying.vue')
  },
  name: 'supplier-buying',
  path: 'supplier-buying',
}

const routeSupplierRoot: RouteRecordRaw = {
  children: [
    routeSupplierDetail,
    routeSupplierFileOverview,
    routeSupplierAccounting,
    routeSupplierBuying,
  ],
  component: async () => {
    return await import('@/components/relationships/organizations/OrganizationDetailBase.vue')
  },
  meta: organizationDetailLayoutMeta,
  path: 'suppliers/:id',
}

export {
  routeSupplierAccounting,
  routeSupplierBuying,
  routeSupplierDetail,
  routeSupplierFileOverview,
  routeSupplierRoot,
}
